import { render, staticRenderFns } from "./ClientHistory.vue?vue&type=template&id=5063469b&scoped=true"
import script from "./ClientHistory.vue?vue&type=script&lang=js"
export * from "./ClientHistory.vue?vue&type=script&lang=js"
import style0 from "./ClientHistory.vue?vue&type=style&index=0&id=5063469b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5063469b",
  null
  
)

export default component.exports